import React from 'react';
import TextElement from './text-element';
import '../css/text-box.less';

export default ({ content, disclaimers=[] }) => {
    return(
        <div className='custom-component text-box'>
        {
            content.map((element, i) =>
                <TextElement key={`text-box-item-${i}`} disclaimers={disclaimers} {...element} />)
        }
        </div>
    )
}
